import type { AnalyticsCoreEventNames, AnalyticsEventNames } from "owa-analytics-events";
import UsageDatapoint from "../../datapoints/UsageDatapoint";
import { logDatapoint } from "./logDatapoint";
import type { CustomData, DatapointOptions, INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT, LogUsageEventTypes, } from "owa-analytics-types";
import type { MailboxInfo } from "owa-client-types";

export function logUsage(eventName: AnalyticsEventNames | AnalyticsCoreEventNames, mailbox: MailboxInfo | typeof INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT | undefined, customData?: CustomData, options?: DatapointOptions, overrideEventType?: LogUsageEventTypes): void {
    const datapoint = new UsageDatapoint(eventName, mailbox, customData, options);
    logDatapoint(datapoint, overrideEventType);
}
